import { render, staticRenderFns } from "./EmergencyMaterialDialog.vue?vue&type=template&id=60264bdc&scoped=true"
import script from "./EmergencyMaterialDialog.vue?vue&type=script&lang=js"
export * from "./EmergencyMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMaterialDialog.vue?vue&type=style&index=0&id=60264bdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60264bdc",
  null
  
)

export default component.exports